// Google Analytics
export const trackGAEvent = (category, action, label, value) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Яндекс.Метрика
export const trackYMEvent = (category, action, label) => {
  if (window.ym) {
    window.ym(100834865, 'reachGoal', `${category}_${action}`, {
      label: label
    });
  }
};

// Общие события
export const trackEvent = (category, action, label, value) => {
  trackGAEvent(category, action, label, value);
  trackYMEvent(category, action, label);
};

// Специфичные события для сайта
export const trackProgramView = (programName) => {
  trackEvent('Programs', 'View', programName);
};

export const trackProgramRegistration = (programName) => {
  trackEvent('Programs', 'Register', programName);
};

export const trackEventView = (eventName) => {
  trackEvent('Events', 'View', eventName);
};

export const trackEventRegistration = (eventName) => {
  trackEvent('Events', 'Register', eventName);
};

export const trackCoachContact = (coachName) => {
  trackEvent('Coaches', 'Contact', coachName);
};

export const trackFormSubmit = (formType) => {
  trackEvent('Forms', 'Submit', formType);
};

export const trackButtonClick = (buttonName) => {
  trackEvent('Buttons', 'Click', buttonName);
};

export const trackPageView = (pageName) => {
  trackEvent('Pages', 'View', pageName);
}; 